export default __webpack_public_path__ + "svg/calendar/2026/7/octubre.svg?95a22038";